import { render, staticRenderFns } from "./DryTypePage.vue?vue&type=template&id=6755ccfc"
import script from "./DryTypePage.vue?vue&type=script&lang=js"
export * from "./DryTypePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports